(ns app.front.ui.filter-button)

(def button-base-style
  (str "w-full border-solid border-ui-violet-100 rounded-full px-4 h-10 flex items-center "
       "justify-between uppercase font-semibold focus:outline-none text-sm overflow-hidden "
       "whitespace-nowrap "))

(def button-style-unselected "bg-white text-ui-violet-100 ")

(def button-style-selected "bg-ui-violet-100 text-ui-white ")

(defn with-total-number [{:keys [selected? total on-click text]}]
  [:button
   {:on-click on-click
    :class    [button-base-style (if selected?
                                   button-style-selected
                                   button-style-unselected)]}
   [:div.flex-1.truncate.mr-3.text-left text]
   [:div.px-1.flex-none
    {:class (cond
              (and (zero? total) selected?) "bg-ui-dark-gray text-ui-violet"
              (and (zero? total) (not selected?)) "bg-ui-dark-gray text-white"
              (not selected?) "bg-ui-violet text-white"
              selected? "bg-white text-ui-violet")}
    total]])
